import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';

// Affordance for cells that reveal detail on hover. Without it the tooltips on
// the sparkline and the percentage cells are effectively undiscoverable.
//
// It sits at low opacity so it does not compete with the figures, and lifts to
// full strength when the row (or the cell itself) is hovered -- hence the
// `group`/`group-hover` pairing the call sites set up.
function HintIcon({ className }) {
  return (
    <FontAwesomeIcon
      icon={faCircleInfo}
      aria-hidden="true"
      className={`${className || ''} align-middle text-gold-400 opacity-60 transition-all duration-150 group-hover:text-gold-600 group-hover:opacity-100`}
      style={{ fontSize: '0.7em' }}
    />
  );
}

export default HintIcon;
